import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import VideoCard from "../Atomics/VideoCard/VideoCard";

// YouTube video list with metadata
const videoData = [
  {
    url: "https://www.youtube.com/embed/S5ZlAQUVqVI",
    time: "3:50",
    title: "Spring Championship Highlights",
    category: "Silverstone • Mar 2025",
    totalvideos: "6",
    verified: true
  },
  {
    url: "https://www.youtube.com/embed/9Dc4v8Npoog",
    time: "4:20",
    title: "Best Races 2025",
    category: "Monaco • Feb 2025",
    totalvideos: "7",
    verified: true
  },
  {
    url: "https://www.youtube.com/embed/64Koco8b5Lo",
    time: "2:58",
    title: "Behind The Scenes",
    category: "Laguna Seca • Jan 2025",
    totalvideos: "4",
    verified: true
  },
  {
    url: "https://www.youtube.com/embed/Ut_IknefD3o",
    time: "3:40",
    title: "Final Lap Intensity",
    category: "Nürburgring • Mar 2025",
    totalvideos: "8",
    verified: true
  },
  {
    url: "https://www.youtube.com/embed/St4JTmJLzH4",
    time: "5:00",
    title: "Driver Reactions",
    category: "Spa • Mar 2025",
    totalvideos: "5",
    verified: true
  },
  {
    url: "https://www.youtube.com/embed/oH6btCKRQCM",
    time: "4:45",
    title: "Qualifying Rush",
    category: "Austin • Apr 2025",
    totalvideos: "9",
    verified: true
  },
  {
    url: "https://www.youtube.com/embed/S1871TB3VO4",
    time: "3:30",
    title: "Trackside Moments",
    category: "Imola • Apr 2025",
    totalvideos: "6",
    verified: true
  },
  {
    url: "https://www.youtube.com/embed/V-Fv1YRxbVs",
    time: "6:15",
    title: "Race Recap – Full Coverage",
    category: "Suzuka • Mar 2025",
    totalvideos: "10",
    verified: true
  }
];

// Get YouTube thumbnail from embed URL
const getThumbnail = (url) => {
  const videoId = url.split("/embed/")[1];
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
};

export default function RacesVideos() {
  return (
    <div className="video-block section-padding">
      <Row>
        <Col md={12}>
          <SectionHeader heading="Recent Events" />
        </Col>

        {videoData.map((video, index) => (
          <Col xl={3} sm={6} className="mb-3" key={index}>
            <Link
  to={{
    pathname: "/video-page",
    state: {
      url: video.url,
      title: video.title,
      category: video.category,
      totalvideos: video.totalvideos,
      relatedVideos: [
        {
          url: "https://www.youtube.com/embed/video1",
          title: "Car Number #1",
          category: "Suzuka • Mar 2025",
        },
        {
          url: "https://www.youtube.com/embed/video2",
          title: "Car Number #2",
         category: "Suzuka • Mar 2025",
        },
        {
          url: "https://www.youtube.com/embed/video3",
          title: "Car Number #3",
          category: "Suzuka • Mar 2025",
        },
        {
          url: "https://www.youtube.com/embed/video4",
          title: "Car Number #4",
          category: "Suzuka • Mar 2025",
        },
        {
          url: "https://www.youtube.com/embed/video5",
          title: "Car Number #5",
          category: "Suzuka • Mar 2025",
        }
      ]
    }
  }}
  style={{ textDecoration: "none" }}
>
  <VideoCard
    imgSrc={getThumbnail(video.url)}
    time={video.time}
    videoTitle={video.title}
    videoCategory={video.category}
    views={video.totalvideos}
    verified={video.verified}
  />
</Link>

          </Col>
        ))}
      </Row>
    </div>
  );
}
